import { useEffect, useState } from "react"
import "./index.less"
import { useNavigate, useParams } from "react-router-dom"
import { RsProjectUser } from "@/commons/interface/project/project"
import { Switch, Table, Tooltip, message } from "antd"
import { addUserProjectPermission, findRsProjectUserListByProject } from "@/api/project/project"
import classNames from "classnames"
import classnames from "classnames"
import SideBarTool from "@/commons/components/side-bar-tool"
import { SideBarBtnType } from "@/commons/enums/side-bar-btn-type"
import { ReactComponent as CheckSvg } from '@/commons/icons/table/check.svg';
import { ReactComponent as CheckedSvg } from '@/commons/icons/table/checked.svg';
import LinkProjectUserModal from "./link-modal"
import { User } from "@/commons/interface/project/user"
import { getUserByLogin, getUsers, getUsersByProjectUuid, getUsersCheckLogin } from "@/api/project/user"
import { USER_TYPE } from "@/commons/enums/user"
import TnMessage from "@/commons/widget/message"
import localStore from "@/commons/store/local-store"

export default function PermissionPanel(second) {
    const navigate = useNavigate();
    const [userList, setUserList] = useState<User[]>([])

    const { projectUuid } = useParams()
    const [addVisible, setAddVisible] = useState<boolean>(false)

    useEffect(() => {
        if (!projectUuid) return
        // 判断是否有权限打开该页面
        getUsersCheckLogin().then(res => {
            if (res.status === 200) {
                let data = res.data || null;
                if (data.type === USER_TYPE.ADMIN) {
                    generateData()
                }
            }
        }).catch(err => {
            localStore.clear();
            navigate("/login");
        })
    }, [projectUuid])

    const generateData = () => {
        // 获取有权限的用户
        getUsersByProjectUuid(projectUuid).then(res => {
            setUserList(res?.data || [])
        })

    }

    const onAddFinish = (uuids: string[]) => {
        addUserProjectPermission(uuids, projectUuid).then(res => {
            TnMessage.success("编辑成功");
            generateData()
        }).finally(() => {
            setAddVisible(false)
        })
    }

    const onAddBtnClick = () => {
        setAddVisible(true)
    }


    return (
        <div className="permission-panel-main">
            <SideBarTool
                activeBtnList={[SideBarBtnType.ADD]}
                onAddBtnClick={onAddBtnClick}
            />
            <div className="user-list">
                <Table
                    rowKey="id"
                    pagination={false}
                    dataSource={userList}
                    className='tn-monix-table'
                    bordered={false}
                    sticky
                >
                    <Table.Column dataIndex="name" title="名称" width='30%' ellipsis
                        render={(value, row: User) => {
                            return (
                                <Tooltip placement="bottom" className="multi-cell">
                                    <div className="multi-text">{value}</div>
                                </Tooltip>
                            )
                        }}
                    />
                </Table>
            </div>

            {addVisible && <LinkProjectUserModal
                fillterList={userList.map(item => item.uuid)}
                visible={addVisible}
                setVisible={setAddVisible}
                onFinish={onAddFinish}
            />}
        </div>
    )
}